import * as React from 'react';
import styles from './index.less';
import { FI18n, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FDrawer from '@/components/FDrawer';
import { Space } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import FResourceLabelEditor from '@/components/FResourceLabelEditor';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';

interface FEditLabelsDrawerProps {
  labels: string[];
  resourceTypeCode?: string;

  onClose?(): void;

  onConfirm?(labels: FEditLabelsDrawerProps['labels']): void;
}

function FEditLabelsDrawer({
  labels,
  resourceTypeCode = '',
  onClose,
  onConfirm,
}: FEditLabelsDrawerProps) {
  const [$open, set$open, get$open] = FUtil.Hook.useGetState<boolean>(true);
  const [$labels, set$labels, get$labels] = FUtil.Hook.useGetState<string[]>(labels);
  const [$changed, set$changed, get$changed] = FUtil.Hook.useGetState<boolean>(false);

  AHooks.useDebounceEffect(
    () => {
      set$labels(labels);
    },
    [labels],
    {
      wait: 100,
    },
  );

  return (
    <FDrawer
      // title={'编辑标签'}
      title={FI18n.i18nNext.t('addtags_title')}
      onClose={() => {
        set$open(false);
      }}
      keyboard={false}
      closable={false}
      open={$open}
      width={580}
      afterOpenChange={(o) => {
        if (!o) {
          onClose?.();
        }
      }}
      topRight={
        <Space size={30}>
          <FComponentsLib.FTextBtn
            type='default'
            onClick={async () => {
              if (get$changed()) {
                const bool: boolean = await fPromiseModalConfirm({
                  title: '提示',
                  description:
                    // 还没有保存，现在离开会导致信息丢失
                    FI18n.i18nNext.t('alarm_leave_page'),
                  okText: FI18n.i18nNext.t('btn_leave'),
                  cancelText: FI18n.i18nNext.t('btn_cancel'),
                });
                if (bool) {
                  set$open(false);
                }
              } else {
                set$open(false);
              }
            }}
          >
            {/* 取消 */}
            {FI18n.i18nNext.t('btn_cancel')}
          </FComponentsLib.FTextBtn>
          <FComponentsLib.FRectBtn
            disabled={!$changed}
            type='primary'
            onClick={() => {
              onConfirm?.(get$labels());
              set$open(false);
            }}
          >
            {/* 保存 */}
            {FI18n.i18nNext.t('btn_save')}
          </FComponentsLib.FRectBtn>
        </Space>
      }
    >
      <FResourceLabelEditor
        value={$labels}
        resourceTypeCode={resourceTypeCode}
        onChange={(value) => {
          // console.log(value, ' *OIJ:LISJDLKfjl;jdslkjl;fkjlkj');
          set$labels(value);
          set$changed(true);
        }}
      />
    </FDrawer>
  );
}

export default FEditLabelsDrawer;
